import React, { FC } from "react";

import { SVGIconComponentProps } from "~/common/types/common";
import { grey } from "../colors/colors";

export const BackIcon: FC<SVGIconComponentProps> = ({
  color = grey[800],
  className,
  size = "24",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M13.25 8.75L9.75 12L13.25 15.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
